RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const PostsModal = views.PostsModal = RivalIQ.views.LayoutView.mixin({
        template: '#discoveryPostsModalTemplate',
        className: 'discover-posts-modal',
        regions: {
            posts: '.x-posts',
            actions: '.modal-layout-dropdown'
        },

        ui: {
            modal: '.modal'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            modalBackdropResizing: RivalIQ.apps.Shell.views.ModalBackdropResizing
        },

        // ModalBackdropResizing Overrides
        getModal: function () {
            const me = this;
            return me.ui.modal;
        },

        getModalBodyClientHeight: function () {
            const me = this;
            return _.head(me.$('.x-posts')).clientHeight;
        },

        // Need to override render here to add buffering since this modal isn't taking advantage of the curation before filters.
        render: function () {
            const me = this;

            let startedBuffering = false;
            if (!RivalIQ.data.CacheLayer.isBuffering()) {
                startedBuffering = true;
                RivalIQ.data.CacheLayer.startBuffering();
            }

            RivalIQ.views.LayoutView.prototype.render.call(me);

            if (startedBuffering) {
                RivalIQ.data.CacheLayer.stopBuffering();
                RivalIQ.data.CacheLayer.flush();
            }

            return me;
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            const Widget = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.DISCOVERY_POST_TABLE);

            const widget = new Widget(me.dashboardModel, {
                baseMetric: {
                    dataSource: 'discovery',
                    dimensions: ['channel', 'postId'],
                    sortable: true
                },
                props: _.create(me.dashboardModel.attributes, {
                    // fake value to make widget render in details mode
                    widgetId: true,
                    // No post details modal
                    noClickThrough: true,
                    orderBy: 3,
                    // table should be read-only
                    sortable: false
                })
            });

            me.posts.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            const metricAttrs = [
                {
                    dataSource: 'discovery',
                    dimensions: ['channel'],
                    property: 'num_posts'
                },
                {
                    dataSource: 'discovery',
                    dimensions: ['channel', 'postId'],
                    property: 'post',
                    sortOrder: null,
                    orderBy: null
                }
            ];

            const collection = new RivalIQ.collections.MetricDefinitions(RivalIQ.metric.build(props, metricAttrs));

            return collection.fetch()
                .then(function (results) {
                    me.totalNumPosts = results.at(0).getValue({
                        format: false
                    });
                    me.numPostsShownMetric = results.at(1).getValue({
                        format: false
                    }).length;
                });
        },

        serializeData: function () {
            const me = this;

            const channel = RivalIQ.data.channels.get(me.getProp('channel'));
            const postWord = RivalIQ.data.channels.get(channel).get('postName');
            return {
                title: `${channel.get('name')} ${s.titleize(`${postWord}s`)}`,
                totalNumPosts: me.totalNumPosts,
                numPostsShownMetric: me.numPostsShownMetric
            };
        }
    });

    PostsModal.show = function (props) {
        props.limit = 8;

        const curation = new RivalIQ.apps.Dashboard.models.Curation(null, props);
        RivalIQ.execute('show:modal', new PostsModal({
            dashboardModel: curation
        }));

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DiscoveryViewedPostsModal, {
            channel: props.channel
        });
    };

}, window.s);
